export class LinkRequestRejectionFailedError extends Error {
    constructor() {
        super('An error occurred while trying to reject link request');
    }
}
